import React, { Component } from "react";
import SignatureCanvas from "react-signature-canvas";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import CircularProgress from '@material-ui/core/CircularProgress';
import Radio from "@material-ui/core/Radio";
import RadioGroup from "@material-ui/core/RadioGroup";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import FormControl from "@material-ui/core/FormControl";
import FormLabel from "@material-ui/core/FormLabel";
import HelpIcon from "@material-ui/icons/Help";
import checkImage from "./ach_check.png";


//import Paper from '@material-ui/core/Paper';
import Grid from "@material-ui/core/Grid";

import KDialog from "../components/kdialog";
import KPopover from "../components/kPopover";

import KFormField from "../components/onboarding/kFormField";
import StatesDropDown from "../components/onboarding/stateDropDown";

import api from "../api";

import misc from "../utils/misc";


import "../css/signatureCanvas.css";
const handCursor = {cursor: 'hand'};
//import { relativeTimeRounding } from 'moment';

//const centerName = 'Kumon Math and Reading Center of Natomas';
//const eftAmountText = '($140) per student per subject or ($260) for dual subjects.';

const validatedFields = [
  { id: "bankName", msg: "Bank Name is required" },
  { id: "bankAccount", msg: "Account Number is required" },

  { id: "bankAccountType", msg: "Account Type is required" },

  { id: "bankRouting", msg: "Routing Number is required" },

  { id: "confirmBankAccount", msg: "Account Number is required" },
  { id: "confirmBankRouting", msg: "Routing Number is required" },

  { id: "accountHolderPhone", msg: "Phone Number is required" },

  { id: "accountHolderName", msg: "Name is required" },
  { id: "addressAddress", msg: "Address is required" },
  { id: "addressCity", msg: "City is required" },
  { id: "addressState", msg: "State is required" },
  { id: "addressZip", msg: "Zip is required" },
  { id: "signature", msg: "Signature is required" },
];

const errorMsgAllFiledsRequired = "Please fill all fields.";
const errorMsgSigRequired = "Please sign in the signature box.";
const errorMsgBankAccountNotMatched =
  "Account Number and Confirm Account don't match.";
const errorMsgBankRoutingNotMatched =
  "Routing Number and Confirm Routing don't match.";

const errorMsgBankRoutingInvalid = 'Invalid Routing Number. Please check/confirm again.'

export default class StepEFT extends Component {
  constructor(props) {
    super(props);
    const store = props.getStore().user;

    this.centerName = props.getStore().center.fullName;
    this.eftAmountText = props.getStore().center.eftAmountText;

    this.state = {
      bankName: store.bankName,
      bankAccountType:
        store.bankAccountType === null ? "checking" : store.bankAccountType,
      bankAccount: store.bankAccount,
      bankRouting: store.bankRouting,
      confirmBankAccount: store.confirmBankAccount,
      confirmBankRouting: store.confirmBankRouting,
      accountHolderName: store.accountHolderName,
      addressAddress: store.addressAddress,
      addressCity: store.addressCity,
      addressState: store.addressState,
      addressZip: store.addressZip,
      accountHolderPhone: store.accountHolderPhone,
      signature: store.signature,
      userMsg: "",
      showAlert: false,
      alertMessages: [],
      alertTitle: "",

      showPopover: false,
    };

    //this.validationCheck = this.validationCheck.bind(this);
    this.isValidated = this.isValidated.bind(this);
    this.onInputValueChanged = this.onInputValueChanged.bind(this);
    this.onSigEnd = this.onSigEnd.bind(this);
    // this.showAchHelp = this.showAchHelp.bind(this);
    this.onAlertClose = this.onAlertClose.bind(this);

    this.popOverRef = React.createRef();
     
  }

  isValidated() {
    let isDataValid = false;
    const userInput = this._grabUserInput();
    const validateNewInput = this._validateData(userInput);

    let isSigValid = validateNewInput["signature"].valid;
    delete validateNewInput.signature;

    let bankAccountMatches = true;
    let bankRoutingMatches = true;
    
    if (userInput.bankAccount !== userInput.confirmBankAccount) {
      bankAccountMatches = false;
    }

    if (userInput.bankRouting !== userInput.confirmBankRouting) {
      bankRoutingMatches = false;
    }
    const routingNumberValid = misc.miscHelper.isRoutingNumberValid(userInput.bankRouting);

    let isFormDataValid = Object.keys(validateNewInput).every((k) => {
      return validateNewInput[k].valid === true;
    });

    isDataValid =
      isFormDataValid && isSigValid && bankAccountMatches && bankRoutingMatches && routingNumberValid;

    // will add later.
    //
    if (isDataValid) {      
      // isDataValid = true; //for now.
      let user = Object.assign({}, this.props.getStore().user, userInput);
      let stData = { user: user };
      this.props.updateStore({
        ...stData,
        savedToCloud: false,
      });
      return this.sendDataToServer(); 
    } else {
      let alertMessages = [];
      if (!isFormDataValid) {
        alertMessages.push(errorMsgAllFiledsRequired);
      }
      if (!isSigValid) {
        alertMessages.push(errorMsgSigRequired);
      }

      if (!bankAccountMatches) {
        alertMessages.push(errorMsgBankAccountNotMatched);
      }

      if (!bankRoutingMatches) {
        alertMessages.push(errorMsgBankRoutingNotMatched);
      }

      if(!routingNumberValid) {
        alertMessages.push(errorMsgBankRoutingInvalid);
      }

      this.setState((state, props) => {
        return { showAlert: true, alertMessages: alertMessages };
      });
    }
    return isDataValid;
  }

  trimStoreData(store) {
    var storeCopy = JSON.parse(JSON.stringify(store));
    delete storeCopy.savedToCloud;
    delete storeCopy.summaryMessage;
    let centerCopy = { id: storeCopy.center.id };
    delete storeCopy.center;
    storeCopy.center = centerCopy;
    let user = storeCopy.user;
    delete user.pin;
    delete user.token;
    delete user.apiKey;
    delete user.confirmBankAccount;
    delete user.confirmBankRouting;
    delete user.student_0;
    delete user.student_1;
    delete user.student_2;
    delete user.student_3;
    delete user.options;
    delete user.promoNA;
    delete user.promotions;
    delete user.sections;
    delete user.reviewTitle;
    delete user.splitPayment; // this causes validation to fail on server
    return storeCopy;
  }

  async sendDataToServer() {
    if (this.state.busy === true) {
      return true;
    }
    this.setState({ busy: true, userMsg: "" });
    const store = this.props.getStore();
    let token = store.user.token;
    let apiKey = store.user.apiKey;
    let data = await api.user.summary(apiKey, token, this.trimStoreData(store));
    this.setState({ busy: false, userMsg: data.message });
    //this.setState({ summaryMessage: res.data.message });
    let m = { summaryMessage: data.message, nextAction: data.nextAction };
    if (data.success === true) {
      this.props.updateStore({
        ...m,
        savedToCloud: false,
      });
    }
    return data.success;
  }

  _grabUserInput() {
    let r = this.state; // this.refs;
    return {
      bankName: r.bankName,
      bankAccountType: r.bankAccountType,
      bankAccount: r.bankAccount,
      bankRouting: r.bankRouting,
      confirmBankAccount: r.confirmBankAccount,
      confirmBankRouting: r.confirmBankRouting,
      accountHolderName: r.accountHolderName,
      addressAddress: r.addressAddress,
      addressCity: r.addressCity,
      addressState: r.addressState,
      addressZip: r.addressZip,
      accountHolderPhone: r.accountHolderPhone,
      signature: this.sigCanvas.isEmpty()
        ? ""
        : this.sigCanvas.getTrimmedCanvas().toDataURL("image/png"),
    };
  }

  _validateData(data) {
    let result = {};
    var _this = this;
    validatedFields.forEach(function (val, index) {
      // let a = _this.validateOne(data, val.id);
      let a = _this.onValueRequiredValidate(val.id, data[val.id], true);
      result = Object.assign(result, { [val.id]: a });
    });

    // custom validation for bank account name, and routing numbers

    if (data.bankRouting !== data.confirmBankRouting) {
      this.setState((state, props) => {
        return { confirmBankRoutingValMsg: "Routing numbers dont match." };
      });
      let a = { valid: false, confirmBankAccount: "" };
      result = Object.assign(result, { confirmBankAccount: a });
    }
    if (data.bankAccount !== data.confirmBankAccount) {
      this.setState((state, props) => {
        return { confirmBankAccountValMsg: "Account numbers dont match." };
      });
      let a = { valid: false, confirmBankAccount: "" };
      result = Object.assign(result, { confirmBankAccount: a });
    }

    return result;
  }

  onInputValueChanged = (id, value) => {
    // let key = val.target.id;
    this.setState({ [id]: value });
  };

  handleAccountTypeChange = (changeEvent) => {
    this.onInputValueChanged("bankAccountType", changeEvent.target.value);
    this.onValueRequiredValidate(
      "bankAccountType",
      changeEvent.target.value,
      true
    ); // do validation
  };

  handleStatesDropdown = (data) => {
    if (data.value === "0")
      // 0 is value for 'Select State'
      data.value = "";
    this.onInputValueChanged(data.name, data.value); // update state
    this.onValueRequiredValidate(data.name, data.value, true); // do validation
    //this.setState({ [data.name]: data.value });
  };

  onValueRequiredValidate = (id, value, updateState) => {
    //console.log(`onValueRequiredValidate for ${id}, ${value}`)
    let valid = value !== "";
    //let attrib = id + 'ValMsg';
    let attrib = "message";
    let msg = "";
    if (!valid) msg = validatedFields.find((o) => o.id === id).msg;
    if (updateState) {
      this.setState((state, props) => {
        return { [attrib]: msg };
      });
    }
    let ret = { valid, [attrib]: msg };
    //console.log(JSON.stringify(ret));
    return ret;
  };

  clearSig = () => {
    this.sigCanvas.clear();
  };
  onSigEnd = (e) => {
    // console.log('on sigend called');
    this.onValueRequiredValidate("signature", this.sigCanvas.toDataURL(), true);
  };

  onSigBegin = (e) => {
    //console.log('on sigend beigin');
  };

  /*
  loading = () =>
    this.state.busy ? (
      <Spinner animation="border" variant="primary" role="status">
        <span className="sr-only">Loading...</span>
      </Spinner>
    ) : (
      ""
    ); */

  loading = () => (
    this.state.busy ? <CircularProgress /> : ''
  );

  userMessage = () =>
    this.state.userMsg === "" ? (
      ""
    ) : (
      <div className="alert alert-warning">{this.state.userMsg}</div>
    );

  alertDlg = () =>
    this.state.showAlert ? (
      <KDialog
        onAlertClose={this.onAlertClose}
        showAlert={true}
        messages={this.state.alertMessages}
      />
    ) : (
      ""
    );

  onAlertClose() {
    this.setState((state, props) => {
      return { showAlert: false };
    });
  }

  showAchHelp = (evt) => {
    this.anchorEl = evt.target;
    this.setState({ showPopover: true });
  }

  onPopverClose = () => {
    this.setState({ showPopover: false });
  }

  popoverHelp = () =>
    
    this.state.showPopover ? (
      <div ref={this.popOverRef}>
        <KPopover open={true} anchorEl={this.anchorEl} onClose={this.onPopverClose}>
          {
            <div>
              <img src={checkImage} alt='ACH Check' />
              <Box m={2}>
                <div className='container'>
                  <Typography component={'div'} variant="body1" align="center">
                    Enter <span className='redText'>Routing Number</span> and <span className='lightGreenText'>Account Number</span> correctly.                    
                    <Typography component={'div'}  variant="body2" color="textSecondary">                      
                      Check Number is not needed.
                    </Typography>
                  </Typography>
                </div>
              </Box>            
            </div>
          }
        </KPopover>
      </div>
      
    ) : (
      ""
    );
  

  render() {
    return (
      <div className="step step4">
        <div>
          <div className="form-group">
            <label className="col-md-12 control-label">
            <Typography                
              variant='h5'>
              Electronic Funds Transfer - Authorization
            </Typography>              
              <div className="your-class mt-3"></div>
            </label>
            <div className="container text-left">
              I authorize <b>{this.centerName}</b> to initiate variable data
              entries to my account identified below in payment for Kumon
              enrollment and monthly tuition charges as shown in previous step. I understand that{" "}
              {this.centerName} will debit my account on the 1st of each month
              or the next business day if that date falls on a Saturday, Sunday,
              or national holiday. I authorize my financial institution
              identified below to debit my account each month. I understand that
              I am in full control of my payment, that I have a right to hold or
              stop this electronic payment simply by giving {this.centerName}{" "}
              timely notice, and that I may revoke this authorization by
              notifying {this.centerName} by the 20th of the current month to be
              effected for the month AFTER next. In addition, I will immediately
              notify {this.centerName} of any changes in the information
              provided on this authorization form. All items returned to{" "}
              {this.centerName} are subject to an automatic debit from my
              account including a maximum returned check fee as permitted by
              law.
              <div className="your-class mt-3"></div>
              <div className="your-class mt-3"></div>
              <form>
                <div className="list-group">
                  <div className="list-group-item list-group-item-action flex-column align-items-start list-group-item-primary">
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1">
                        Section 1 - FINANCIAL INSTITUTION INFORMATION
                      </h5>
                    </div>
                  </div>
                  <div className="your-class mt-3"></div>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}></Grid>
                    <Grid item xs={12} sm={6}></Grid>
                  </Grid>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        id="bankName"
                        layout="horizontal"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        label="Bank Name"
                        value={this.state.bankName}
                        placeholder="Bank Name"
                        errorMsg={this.state.bankNameValMsg}
                      ></KFormField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <FormControl component="div">
                        <FormLabel component="legend">
                          Type of Account
                        </FormLabel>
                        <RadioGroup
                          row
                          aria-label="accountType"
                          name="accountType"
                          value={this.state.bankAccountType}
                          onChange={this.handleAccountTypeChange}
                        >
                          <FormControlLabel
                            value="checking"
                            control={<Radio />}
                            label="Checking"
                          />
                          <FormControlLabel
                            value="savings"
                            control={<Radio />}
                            label="Savings"
                          />
                        </RadioGroup>
                      </FormControl>
                    </Grid>
                  </Grid>

                  <div className="your-class mt-3"></div>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <Grid container direction="row" alignItems="center">
                        <KFormField
                          id="bankRouting"
                          onChange={this.onInputValueChanged}
                          label="9-Digit Routing Number"
                          maxLength="9"
                          maxDigits="9"
                          validator={this.onValueRequiredValidate}
                          placeholder="Routing #"
                          value={this.state.bankRouting}
                          errorMsg={this.state.bankRoutingValMsg}
                        ></KFormField>
                        <Box><HelpIcon style={handCursor} 
                         onClick={(e) => this.showAchHelp(e)}   
                         color="secondary"></HelpIcon></Box>
                      </Grid>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <Grid container direction="row" alignItems="center">
                        <KFormField
                          id="bankAccount"
                          onChange={this.onInputValueChanged}
                          maxLength="16"
                          validator={this.onValueRequiredValidate}
                          label="Account Number"
                          defaultValue={this.state.bankAccount}
                          placeholder="Account #"
                          errorMsg={this.state.bankAccountValMsg}
                        ></KFormField>
                        <Box><HelpIcon style={handCursor} 
                         onClick={(e) => this.showAchHelp(e)}   
                         color="secondary"></HelpIcon></Box>
                        
                      </Grid>
                    </Grid>
                  </Grid>

                  <div className="your-class mt-3"></div>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        id="confirmBankRouting"
                        maxDigits="9"
                        maxLength="9"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        label="Confirm Routing"
                        defaultValue={this.state.confirmBankRouting}
                        placeholder="Confirm Routing #"
                        errorMsg={this.state.confirmBankRoutingValMsg}
                      ></KFormField>
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        id="confirmBankAccount"
                        maxLength="16"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        label="Confirm Account"
                        defaultValue={this.state.confirmBankAccount}
                        placeholder="Confirm Account #"
                        errorMsg={this.state.confirmBankAccountValMsg}
                      ></KFormField>
                    </Grid>
                  </Grid>
                </div>

                <div className="your-class mt-3"></div>
                <div className="list-group">
                  <div className="list-group-item list-group-item-action flex-column align-items-start list-group-item-primary">
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1">Section 2 - AUTHORIZATION</h5>
                    </div>
                  </div>

                  <div className="your-class mt-3"></div>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        id="accountHolderName"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        label="Name on Account"
                        defaultValue={this.state.accountHolderName}
                        placeholder="Account Holder Name"
                        errorMsg={this.state.accountHolderNameValMsg}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        className="form-group col-md-2"
                        type="tel"
                        maxLength="12"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        id="accountHolderPhone"
                        label="Phone Number"
                        defaultValue={this.state.accountHolderPhone}
                        placeholder="Phone Number"
                        errorMsg={this.state.accountHolderPhoneValMsg}
                      ></KFormField>
                    </Grid>
                  </Grid>

                  <div className="your-class mt-3"></div>
                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        id="addressAddress"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        label="Account Holder Address"
                        defaultValue={this.state.addressAddress}
                        placeholder="Account Holder Address"
                        errorMsg={this.state.addressAddressValMsg}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        id="addressCity"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        label="City"
                        defaultValue={this.state.addressCity}
                        placeholder="City"
                        errorMsg={this.state.addressCityValMsg}
                      />
                    </Grid>
                  </Grid>

                  <div className="your-class mt-3"></div>

                  <Grid container spacing={3}>
                    <Grid item xs={12} sm={6}>
                      <StatesDropDown
                        id="addressState"
                        errorMsg={this.state.addressStateValMsg}
                        onChange={this.handleStatesDropdown}
                      />
                    </Grid>
                    <Grid item xs={12} sm={6}>
                      <KFormField
                        className="form-group col-md-2"
                        maxLength="12"
                        onChange={this.onInputValueChanged}
                        validator={this.onValueRequiredValidate}
                        id="addressZip"
                        label="Zip"
                        defaultValue={this.state.addressZip}
                        placeholder="Zip"
                        errorMsg={this.state.addressZipValMsg}
                      ></KFormField>
                    </Grid>
                  </Grid>

                  <div className="your-class mt-3"></div>
                </div>
                <div className="list-group">
                  <div className="list-group-item list-group-item-action flex-column align-items-start list-group-item-primary">
                    <div className="d-flex w-100 justify-content-between">
                      <h5 className="mb-1">Section 3 - SIGNATURE</h5>
                    </div>
                  </div>
                  <div className="your-class mt-3"></div>
                  <div className="row d-flex aaajustify-content-start">
                    <div className="col">
                      <div className="aa_card-header bg-transparent">
                        Please sign below. By signing, you are agreeing to the
                        following.
                        <ul>
                          <li>
                            You have read and agreed to all the center terms and
                            conditions mentioned in the previous page.
                          </li>
                          <li>
                            You have verified the bank account information and
                            confirm it is correct.
                          </li>
                          <li>
                            You have verfied and entered the bank Routing Number and Account Number correctly.
                          </li>                        
                          <li>
                            You are an authorized user of this bank account.
                          </li>
                          <li>
                            You understand and agree to EFT Authorization.
                          </li>
                        </ul>
                        <b>Today's Date : {new Date().toDateString()}</b>
                      </div>
                      <div>
                        <br />
                        <SignatureCanvas
                          onBegin={this.onSigBegin}
                          onEnd={this.onSigEnd}
                          penColor="#0275d8"
                          ref={(ref) => {
                            this.sigCanvas = ref;
                          }}
                          canvasProps={{ className: "signatureCanvas" }}
                        />
                        <br />
                        <button
                          type="button"
                          onClick={this.clearSig}
                          className="btn btn-secondary"
                        >
                          Clear Signature
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <div className="row d-flex justify-content-center">
              <div className="col-sm-5"></div>
              <div className="col-sm-7">
                {this.loading()}
                {this.userMessage()}
              </div>
            </div>

            {this.alertDlg()}
            {this.popoverHelp()}
            
          </div>
        </div>
      </div>
    );
  }
}

// <div role="alert" className="form-field-error" >{this.state.signatureValMsg}</div>

/*
require "base64"
data_uri = "data:image/png;base64,iVBORw0K..."
encoded_image = data_uri.split(",")[1]
decoded_image = Base64.decode64(encoded_image)
File.open("signature.png", "wb") { |f| f.write(decoded_image) }*/

/*

https://americanexpress.io/clean-code-dirty-code/

const MyOtherComponent = ({ type }) => (
  <OtherComponent type={type} className="colorful" foo={123} bar={456} />
);
const MyComponent = () => (
  <div>
    <MyOtherComponent type="a" />
    <MyOtherComponent type="b" />
  </div>
); */
